import { isHumanAuditForProgramAdmins } from '@/utils/caseActions';

import type { Agent, CaseItem } from './types';

/**
 * Programs of the cases whose human audit is reserved for Program Admins and above
 * (BV-2657: transportation or unifiedmedbv in human_audit), once each.
 */
export function programAdminOnlyPrograms(cases: CaseItem[]): string[] {
  const programs = new Set<string>();
  for (const c of cases) {
    if (c.programId && isHumanAuditForProgramAdmins(c.status, c.workflowType)) {
      programs.add(c.programId);
    }
  }
  return [...programs];
}

/**
 * Agents the cases can be reassigned to: everyone, minus users whose role is below Program
 * Admin on the program of any reserved case (`programs`, from `programAdminOnlyPrograms`).
 */
export function reassignableForCases(
  agents: Agent[],
  programs: string[],
  isBelow: (programId: string | undefined, userId: string) => boolean,
): Agent[] {
  if (programs.length === 0) return agents;
  return agents.filter(agent => !programs.some(programId => isBelow(programId, agent.id)));
}
